import { Heading2, Description } from '@casavo/base-ui'
import useTranslation from 'next-translate/useTranslation'

import { SimilarPropertiesCarousel } from '@/components/SimilarPropertiesCarousel'
import { Divider } from '@/design-lib/components/Divider'
import { sprinkles } from '@/design-lib/style-theme/sprinkles.css'
import { CardData, CardDataListing, CardDataPriority } from '@/types/property-card'

export const SimilarPropertiesSection: React.FC<{
  similarListings: CardDataListing[]
  similarPriorities: CardDataPriority[]
}> = ({ similarListings, similarPriorities }) => {
  const { t } = useTranslation()

  return (
    <>
      <Divider />
      <Heading2 alignment="center" className={sprinkles({ paddingY: 'm' })}>
        {t('priority:Priority_DetailPage_SimilarProperties_Title')}
      </Heading2>
      <Description alignment="center" className={sprinkles({ marginBottom: '2xl' })}>
        {t('priority:Priority_DetailPage_SimilarProperties_Description')}
      </Description>

      <SimilarPropertiesCarousel similarListings={similarListings} similarPriorities={similarPriorities} />
    </>
  )
}
